var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgColumnChart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.66683 0.833336C1.20659 0.833336 0.833496 1.20643 0.833496 1.66667V17.5C0.833496 18.4205 1.57969 19.1667 2.50016 19.1667H18.3335C18.7937 19.1667 19.1668 18.7936 19.1668 18.3333C19.1668 17.8731 18.7937 17.5 18.3335 17.5L3.3335 17.5C2.87326 17.5 2.50016 17.1269 2.50016 16.6667V1.66667C2.50016 1.20643 2.12707 0.833336 1.66683 0.833336Z",
    fill: "#FDF4F4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.00016 11.6667C5.00016 11.2064 5.37326 10.8333 5.8335 10.8333C6.29373 10.8333 6.66683 11.2064 6.66683 11.6667V14.1667C6.66683 14.6269 6.29373 15 5.8335 15C5.37326 15 5.00016 14.6269 5.00016 14.1667V11.6667Z",
    fill: "#FDF4F4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.16683 8.33334C8.70659 8.33334 8.3335 8.70643 8.3335 9.16667V14.1667C8.3335 14.6269 8.70659 15 9.16683 15C9.62707 15 10.0002 14.6269 10.0002 14.1667V9.16667C10.0002 8.70643 9.62707 8.33334 9.16683 8.33334Z",
    fill: "#FDF4F4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6668 6.66667C11.6668 6.20643 12.0399 5.83334 12.5002 5.83334C12.9604 5.83334 13.3335 6.20643 13.3335 6.66667V14.1667C13.3335 14.6269 12.9604 15 12.5002 15C12.0399 15 11.6668 14.6269 11.6668 14.1667V6.66667Z",
    fill: "#FDF4F4"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8335 3.33334C15.3733 3.33334 15.0002 3.70643 15.0002 4.16667V14.1667C15.0002 14.6269 15.3733 15 15.8335 15C16.2937 15 16.6668 14.6269 16.6668 14.1667V4.16667C16.6668 3.70643 16.2937 3.33334 15.8335 3.33334Z",
    fill: "#FDF4F4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgColumnChart);
export default __webpack_public_path__ + "static/media/column-chart.d3ca1c2ee69b6897af59d7acb117a10d.svg";
export { ForwardRef as ReactComponent };